import { useState } from 'react';
import axios from 'axios';

const categories = [
  'T-shirt', 'Short', 'Caps', 'Shorts', 'Trousers',
  'Skirts', 'Tops', 'Dress'
];

export default function AddProduct() {
  const [form, setForm] = useState({
    brand: '',
    name: '',
    description: '',
    price: '',
    details: '',
    category: '',
    image: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setForm({ ...form, image: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in form) {
      formData.append(key, form[key]);
    }

    const token = localStorage.getItem('token'); // ✅ Get token from localStorage

    try {
      const res = await axios.post(
        'https://shophub-server.vercel.app/api/products/add',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}` // ✅ Set Authorization header
          }
        }
      );
      alert('Product added!');
    } catch (err) {
           console.error('Failed to add product:', err);
      alert('Failed to add product: ' + (err.response?.data?.message || err.message));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 max-w-md mx-auto">
      <input
        name="brand"
        placeholder="Brand"
        onChange={handleChange}
        className="w-full border p-2 rounded"
      />
      <input
        name="name"
        placeholder="Product Name"
        onChange={handleChange}
        className="w-full border p-2 rounded"
      />
      <textarea
        name="description"
        placeholder="Short description"
        onChange={handleChange}
        className="w-full border p-2 rounded"
      />
      <input
        type="number"
        name="price"
        placeholder="Price"
        onChange={handleChange}
        className="w-full border p-2 rounded"
      />
      <textarea
        name="details"
        placeholder="Detailed description"
        onChange={handleChange}
        className="w-full border p-2 rounded"
      />
      <select
        name="category"
        onChange={handleChange}
        className="w-full border p-2 rounded"
        defaultValue=""
      >
        <option disabled value="">Select Category</option>
        {categories.map(cat => (
          <option key={cat} value={cat}>{cat}</option>
        ))}
      </select>
      <input
        type="file"
        name="image"
        accept="image/*"
        onChange={handleChange}
        className="w-full"
      />
      <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
        Add Product
      </button>
    </form>
  );
}
